import { MemberadminTFunction } from '@dap/memberadmin/i18n';
import { CountryCode } from '@shared/types';

export function getOrgRegistryStatusTitle(
  brandCountry: string | undefined,
  t: MemberadminTFunction
): string {
  if (brandCountry === CountryCode.Norway) {
    return t('memberadmin.filter.orgStatus.titleBrreg');
  }
  if (brandCountry === CountryCode.Sweden) {
    return t('memberadmin.filter.orgStatus.titleBolagsverket');
  }
  return t('memberadmin.filter.orgStatus.title');
}
